import React from "react";
import { Checkbox } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { format } from "date-fns";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { useGetDirectionsV2 } from "~/entity/Directions";
import { Select } from "~/shared/ui/Select";

import cls from "./Regional.less";

interface RegionalProps {
  control: any;
  isShowSelect: boolean;
  nameCheckbox: string;
  nameSelect: string;
  label: string;
  error?: any;
  disabled?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
}

export const Regional = (props: RegionalProps) => {
  const {
    control,
    isShowSelect,
    nameCheckbox,
    nameSelect,
    label,
    error,
    disabled,
    onCheckboxChange,
  } = props;
  const { t } = useTranslation();

  const { data } = useGetDirectionsV2({
    status: "active",
    ActualOn: format(new Date(), "yyyy-MM-dd"),
  });

  const options = (data?.items || []).map((item) => ({
    label: item.name,
    value: item.instanceId,
  }));

  return (
    <Flex gap={16} justify={"space-between"} className={cls.container}>
      <Controller
        name={nameCheckbox}
        control={control}
        render={({ onChange, value }) => (
          <Checkbox
            checked={value}
            onChange={() => {
              const next = !value;
              onChange(next);
              onCheckboxChange?.(next);
            }}
            label={label}
            disabled={disabled}
          />
        )}
      />
      <div
        className={cls.right}
        style={{ display: isShowSelect ? undefined : "none" }}
      >
        <span className={cls.directionLabel}>{t("roles.direction")}</span>
        <Controller
          name={nameSelect}
          control={control}
          render={({ onChange, value }) => {
            const selectedValues: number[] = Array.isArray(value) ? value : [];
            return (
              <Select
                disabled={disabled}
                mode="multiple"
                onChange={(selected: number[]) => {
                  onChange(Array.isArray(selected) ? selected : []);
                }}
                value={selectedValues}
                options={options}
                placeholder={t("roles.direction")}
                status={error ? "error" : undefined}
                maxTagCount="responsive"
                allowClear
              />
            );
          }}
        />
        {error && (
          <div style={{ color: "#ff4d4f", fontSize: 12, marginTop: 4 }}>
            {error.message}
          </div>
        )}
      </div>
    </Flex>
  );
};
